export interface MusicCredit {
	title: string;
	artist: string;
	artistUrl: string;
	license: string;
	licenseUrl: string;
}

export const musicCredits: MusicCredit[] = [
	{
		title: 'Beachfront Celebration',
		artist: 'Kevin MacLeod',
		artistUrl: 'https://incompetech.com',
		license: 'Creative Commons: By Attribution 4.0 License',
		licenseUrl: 'http://creativecommons.org/licenses/by/4.0/',
	},
	{
		title: 'Funky Chunk',
		artist: 'Kevin MacLeod',
		artistUrl: 'https://incompetech.com',
		license: 'Creative Commons: By Attribution 4.0 License',
		licenseUrl: 'http://creativecommons.org/licenses/by/4.0/',
	},
	{
		title: 'Hustle',
		artist: 'Kevin MacLeod',
		artistUrl: 'https://incompetech.com',
		license: 'Creative Commons: By Attribution 4.0 License',
		licenseUrl: 'http://creativecommons.org/licenses/by/4.0/',
	},
	{
		title: 'Private Eye',
		artist: 'Kevin MacLeod',
		artistUrl: 'https://incompetech.com',
		license: 'Creative Commons: By Attribution 4.0 License',
		licenseUrl: 'http://creativecommons.org/licenses/by/4.0/',
	},
	{
		title: 'Your Call',
		artist: 'Kevin MacLeod',
		artistUrl: 'https://incompetech.com',
		license: 'Creative Commons: By Attribution 4.0 License',
		licenseUrl: 'http://creativecommons.org/licenses/by/4.0/',
	},
];
